import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { AppDispatch } from "store/store";

import {
  initialize,
  setActivityFilter,
  setAutomatedCollectionTab,
  setEntityFilter,
  setIsUtilityConnectionsVisible,
  setUtilityProviderFilter,
} from "./collectionStatusStore";
import { AutomatedCollectionTab } from "./types";

export interface UseCollectionStatusStore {
  initialize: () => void;
  setAutomatedCollectionTab: (tab: AutomatedCollectionTab) => void;
  setIsUtilityConnectionsVisible: (visible: boolean) => void;
  setEntityFilter: (filter: string[]) => void;
  setUtilityProviderFilter: (filter: string[]) => void;
  setActivityFilter: (filter: string[]) => void;
}

export const useCollectionStatusStore = (): UseCollectionStatusStore => {
  const dispatch = useDispatch<AppDispatch>();

  return {
    initialize: useCallback(() => dispatch(initialize()), [dispatch]),

    setAutomatedCollectionTab: useCallback(
      (tab: AutomatedCollectionTab) => dispatch(setAutomatedCollectionTab(tab)),
      [dispatch]
    ),

    setIsUtilityConnectionsVisible: useCallback(
      (visible: boolean) => dispatch(setIsUtilityConnectionsVisible(visible)),
      [dispatch]
    ),

    setEntityFilter: useCallback(
      (filter: string[]) => dispatch(setEntityFilter(filter)),
      [dispatch]
    ),

    setUtilityProviderFilter: useCallback(
      (filter: string[]) => dispatch(setUtilityProviderFilter(filter)),
      [dispatch]
    ),

    setActivityFilter: useCallback(
      (filter: string[]) => dispatch(setActivityFilter(filter)),
      [dispatch]
    ),
  };
};
